import * as React from "react"
import trans from "trans"
import Mergado from "app/helpers/mergado"

import {
    DataCell,
    Theme,
    Select,
    Grid,
    GridCell,
    PopupHint,
    Icon,
} from "@bdfx/mergado-ui-kit"

import {
    availableValidationOptionsMistakeByUser,
    renderItemId,
    renderName, SetByUser,
} from "./product-table";
import {projectId} from "app/helpers/api";
import {isGodModeOn} from "app/helpers/api";
import {URL} from "app/config/api-config";
import {DarkGrayColor} from "app/helpers/colors";
import {StyledDataRow} from "./product-table-table";
import {ExtendedProductType} from "../types";
import { intboolean } from "app/types/app-types";
import { allowObjectToImageRatioForUsers, allowSuperadminForUsers } from "template-edit/components/helper";

interface Props {
    image: ExtendedProductType
    showModal: Function
    getEmptyFiltersForm: Function
    changeSetByUser: Function
    idx: number
    userId: number
}

const MERGADO_APP = `https://app.mergado.com/projects/${projectId}/product`

class ValidationRow extends React.Component<Props> {

    constructor(props: Props) {
        super(props)
    }

    renderBoolean = (value: intboolean | boolean | string) => {
        const isTrue = value === 1 || value === '1' || value === true
        const isFalse = value === 0 || value === '0' || value === false
        const type = isTrue ? "check-circle" : (isFalse ? 'close-light' : '')
        return isTrue || isFalse ? <Icon type={type} color={isTrue ? Theme.blue : Theme.red} /> : ''
    }

    render() {
        const { image, idx, userId } = this.props
        const icon = (status) => {
            switch (status) {
                case 'OK':
                    return <Icon type={'check'} color={Theme.green} text={trans('status_' + image.validations_status)}/>
                case 'ERROR':
                    return <Icon type={'exclamation'} color={Theme.red} text={trans('status_' + image.validations_status)}/>
                case 'N/A':
                    return <PopupHint icon={<Icon type={'exclamation'} size={12} text={trans('status_' + image.validations_status)} color={'#ddd'} />}>
                        <span>{trans('info_status_suspicious')}</span>
                    </PopupHint>

                case 'NOT_OK':
                    return <Icon type={'close'} color={Theme.red} text={trans('status_' + image.validations_status)}/>
                default:
                    return <Icon type={'question'} color={DarkGrayColor} text={trans('status_' + image.validations_status)}/>
            }
        }

        const addStatusClass = (image.validations_status === 'OK') ? 'ok' : (image.validations_status === 'ERROR' ? 'error' : (image.validations_status === 'NOT_OK' ? 'not-ok' : ''))

        const mergadoProductUrl = `${MERGADO_APP}/${image.product_id}`
        const previewUrl = `${URL.laravelBase}images?template_id=${image.template_id}&product_id=${image.product_id}&nocache=1`

        const isAllowSpecialFields = (allowObjectToImageRatioForUsers.includes(userId) || isGodModeOn)

        return <StyledDataRow key={`${image.image_id}`} dataId={`validations-${image.product_id}`}>
            {isGodModeOn &&
            <DataCell key={'image_id'}>{image.image_id}</DataCell>
            }

            <DataCell key={'product_image'} className={'clickable centered'} onClick={() => this.props.showModal(idx)}>
                <img src={image.image_link} height={50}/>
            </DataCell>

            <DataCell key={'product_name'} className='clickable left'>
                {renderName(image.elements_name)}
                <br/>
                {renderItemId(image.elements_item_id)}
            </DataCell>

            <DataCell key={'status'} className={'status ' + addStatusClass}>
                {image.validations_mistake_set_by_user !== null ? <span>({trans('set_by_user')})</span> : icon(image.validations_status)}

                {image.validations_status &&
                    <Select
                        value={image.validations_mistake_set_by_user !== null ? `${image.validations_mistake_set_by_user}` : null}
                        options={availableValidationOptionsMistakeByUser}
                        onChange={(value) => this.props.changeSetByUser(image.image_id, idx, (value !== '100' ? parseInt(value) : null))}
                    />
                }
            </DataCell>

            {userId && (allowSuperadminForUsers.includes(userId)) &&
            <DataCell key={'status_reason'}>{image.validations_status_reason && trans(image.validations_status_reason.toLocaleLowerCase())}</DataCell>
            }

            <DataCell key={'correctness_percentage_offset'}>{image.validations_correctness_percentage_offset && image.validations_correctness_percentage_offset + ' %'}</DataCell>
            <DataCell key={'validations_has_alpha'}>{this.renderBoolean(image.validations_has_alpha)}</DataCell>

            {isAllowSpecialFields && <React.Fragment>
                <DataCell key={'validations_empty_background_probability'}>{image.validations_empty_background_probability && image.validations_empty_background_probability + ' %'}</DataCell>
                <DataCell key={'validations_object_to_image_ratio'}>{image.validations_object_to_image_ratio && image.validations_object_to_image_ratio}</DataCell>
                <DataCell key={'validations_object_bounding_box_to_image_ratio'}>{image.validations_object_bounding_box_to_image_ratio && image.validations_object_bounding_box_to_image_ratio}</DataCell>
            </React.Fragment>}

            <DataCell key={'links'} className='centered clickable'>
                <Grid cols={`repeat(5, 1fr)`} className={'product-links'}>
                    {image.image_link &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(image.image_link)}>
                        <Icon type={'file-image-o'} color={Theme.blue} title={trans("link_image_url")} size={20} />
                        </div>
                    </GridCell>
                    }
                    {previewUrl &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(previewUrl)}>
                        <Icon type={'feedimageeditor'} title={trans("link_fie")} size={20} />
                        </div>
                    </GridCell>
                    }
                    {mergadoProductUrl &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(mergadoProductUrl)}>
                        <Icon type={'mergado'} title={trans("link_mergado")} size={20} />
                        </div>
                    </GridCell>
                    }
                    {image.elements_url &&
                    <GridCell className='clickable'>
                        <div onClick={() => Mergado.openWindow(image.elements_url)}>
                        <Icon type={'shopping-basket'} color={DarkGrayColor} title={trans("link_eshop")} size={20} />
                        </div>
                    </GridCell>
                    }
                </Grid>
            </DataCell>
        </StyledDataRow>
    }
}


export default ValidationRow

